import React from "react";
import '../../Components/loader/loader.css';
import { PropagateLoader } from "react-spinners";

const Loader = () => {
    return (
        <div className="loader-main-div">
            <div className="loader-second-div">

                

                <PropagateLoader
                    color={'#eb3b2e'}
                    // loading={loading}
                    // cssOverride={override}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        </div>
    )

}

export default Loader;